import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Typeahead } from 'react-bootstrap-typeahead';
import './ProdigyTypeahead.scss';

/**
 *  Prodigy Styled Typeahead List
 */
function ProdigyTypeahead(props) {
  const {
    options,
    placeholder = 'Select...',
    className = 'p-typeahead',
    disabled,
    onChange,
    value,
    id,
    label,
    labelKey,
    filterBy,
    error,
    info,
    required,
  } = props;

  const [displayValue, setDisplayValue] = useState('');
  const [tmpValue, setTmpValue] = useState('');

  useEffect(() => {
    setDisplayValue(value);
  }, [value]);

  const getDisplayLabel = () => {
    const key = labelKey || 'label';
    return displayValue && displayValue[key] ? [displayValue[key]] : tmpValue;
  };

  return (
    <div
      className={classNames(
        'prodigy-typeahead-container',
        error ? 'prodigy-typeahead-container-error' : '',
        disabled ? 'prodigy-typeahead-container-disabled' : '',
      )}
    >
      <label htmlFor={id}>
        {label || ''}
        {required && ' *'}
      </label>
      <Typeahead
        id={id}
        className={className}
        placeholder={placeholder}
        selectHintOnEnter
        clearButton
        labelKey={labelKey || 'label'}
        filterBy={filterBy || 'label'}
        value={value}
        selected={getDisplayLabel()}
        options={options}
        isDisabled={disabled || false}
        clearValue={onChange}
        onChange={changedValue => {
          setTmpValue(changedValue);
          onChange(changedValue);
        }}
      />
      {info && <span className="prodigy-input-info">{info}</span>}
      {error && error.msg && (
        <span className="prodigy-input-error">{error.msg}</span>
      )}
    </div>
  );
}

ProdigyTypeahead.propTypes = {
  id: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  filterBy: PropTypes.string,
  label: PropTypes.string,
  labelKey: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.any,
  disabled: PropTypes.bool,
  value: PropTypes.object,
  error: PropTypes.object,
  info: PropTypes.string,
  required: PropTypes.bool,
};

export default ProdigyTypeahead;
